import { init } from './index'
import type { InstrucktConfig } from './types'

const DEFAULT_CRM_BASE = 'https://crmai.enacton.com'
const SCRIPT_EL = currentScript()

function currentScript(): HTMLScriptElement | null {
  return document.currentScript instanceof HTMLScriptElement ? document.currentScript : null
}

function endpointFromCrmBase(crmBase: string): string {
  try {
    return new URL('/api/annotate', crmBase).toString().replace(/\/$/, '')
  } catch {
    return new URL('/api/annotate', DEFAULT_CRM_BASE).toString().replace(/\/$/, '')
  }
}

function readConfig(): InstrucktConfig | null {
  const dataset = SCRIPT_EL?.dataset
  const projectId = dataset?.projectId?.trim()

  if (!projectId) {
    console.warn('visual-qa: missing data-project-id on widget script')
    return null
  }

  const crmBase = dataset?.crmBase?.trim() || DEFAULT_CRM_BASE
  const endpoint = dataset?.endpoint?.trim() || endpointFromCrmBase(crmBase)

  return {
    projectId,
    endpoint,
    crmBase,
    authMode: dataset?.authMode?.trim() === 'none' ? 'none' : 'crm-redirect',
    tokenQueryParam: dataset?.tokenQueryParam?.trim() || undefined,
    tokenStorageKey: dataset?.tokenStorageKey?.trim() || undefined,
    environment: dataset?.environment?.trim() || undefined,
  }
}

function boot(): void {
  const config = readConfig()
  if (config) init(config)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true })
} else {
  boot()
}
